<template>
    <div class="ai_register_result">
        <div class="dialog">
            <div class="close" @click="close"></div>
            <div class="txtlist">
                <div class="it url">AI工具平台：https://ai.workeredu.cn/</div>
                <div class="it tel">手机：{{ detail.account }}</div>
                <div class="it pwd">
                    <span
                        >密码：<span ref="copyParagraph">{{ detail.password }}</span></span
                    >
                    <span class="copy" @click="copyDynamic">复制密码</span>
                </div>
            </div>
            <div class="foot-buttons">
                <div class="abtn btnclose" @click="close">我知道了</div>
            </div>
        </div>
    </div>
</template>

<script>
import useClipboard from 'vue-clipboard3'
const { toClipboard } = useClipboard()
import { showSuccessToast, showFailToast, showToast } from 'vant';
export default {
    components: {},
    props:['data'],
    data() {
        return {
            detail: { 
                account: '',
                password: ''
            }
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo
        },
        categoryList() {
            return this.$store.state.categoryList
        },
        env() {
            return this.$store.state.env
        }
    },
    created() {
        this.detail = this.data;
    },
    mounted() {},
    methods: {
        close() {
            this.$emit('close')
        },
        copy() {},
        async copyDynamic() {
            try {
                await toClipboard(this.detail.password)
                showSuccessToast('复制成功'); 
            } catch (e) {
                showFailToast('复制失败'); 
            }
        }
    }
}
</script>
<style scoped lang="scss">
$s1024: 1;
$s750: 1;
.ai_register_result {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.8);
    .dialog {
        width: 3.74rem;
        height: 2.45rem;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        background: url(../assets/dialog_ai_register.png) no-repeat;
        background-size: contain;
        @media screen and (max-width: 1024px) {
            width: (3.74rem * $s1024);
            height: (2.45rem * $s1024);
        }
        @media screen and (max-width: 750px) {
            width: (6.58rem * $s750);
            height: (4.32rem * $s750);
        }
        .close {
            width: 0.66rem;
            height: 0.66rem;
            position: absolute;
            right: 0;
            top: 0;
            cursor: pointer;
            @media screen and (max-width: 1024px) {
                width: (0.66rem * $s1024);
                height: (0.66rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                width: (0.66rem * $s750);
                height: (0.66rem * $s750);
                right: (0.26rem * $s750);
                top: (0.16rem * $s750);
            }
        }
        .txtlist {
            position: absolute;
            left: 0.9rem;
            top: 0.62rem;
            @media screen and (max-width: 1024px) {
                left: (0.9rem * $s1024);
                top: (0.62rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                left: (1.5rem * $s750);
                top: (1.2rem * $s750);
            }
            .it {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-content: center;
                align-items: center;
                font-size: 0.12rem;
                line-height: 2;
                color: #6f6e71;
                margin-bottom: 0.08rem;
                @media screen and (max-width: 1024px) {
                    font-size: (0.12rem * $s1024);
                    margin-bottom: (0.08rem * $s1024);
                }
                @media screen and (max-width: 750px) {
                    font-size: (0.22rem * $s750);
                    margin-bottom: (0.24rem * $s750);
                }
                &.url::before {
                    content: ' ';
                    display: block;
                    width: 0.11rem;
                    height: 0.11rem;
                    background: url(../assets/icon_url.png) no-repeat center center;
                    background-size: contain;
                    margin-right: 0.1rem;
                    @media screen and (max-width: 1024px) {
                        width: (0.11rem * $s1024);
                        height: (0.11rem * $s1024);
                        margin-right: (0.08rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        width: (0.22rem * $s750);
                        height: (0.24rem * $s750);
                        margin-right: (0.08rem * $s750);
                    }
                }
                &.tel::before {
                    content: ' ';
                    display: block;
                    width: 0.11rem;
                    height: 0.13rem;
                    background: url(../assets/icon_phone.png) no-repeat center center;
                    background-size: contain;
                    margin-right: 0.1rem;
                    @media screen and (max-width: 1024px) {
                        width: (0.11rem * $s1024);
                        height: (0.11rem * $s1024);
                        margin-right: (0.08rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        width: (0.22rem * $s750);
                        height: (0.24rem * $s750);
                        margin-right: (0.08rem * $s750);
                    }
                }
                &.pwd::before {
                    content: ' ';
                    display: block;
                    width: 0.11rem;
                    height: 0.13rem;
                    background: url(../assets/icon_pwd.png) no-repeat center center;
                    background-size: contain;
                    margin-right: 0.1rem;
                    @media screen and (max-width: 1024px) {
                        width: (0.11rem * $s1024);
                        height: (0.11rem * $s1024);
                        margin-right: (0.08rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        width: (0.22rem * $s750);
                        height: (0.24rem * $s750);
                        margin-right: (0.08rem * $s750);
                    }
                }
                .copy {
                    background-color: #6f6e71;
                    border-radius: 0.04rem;
                    color: #fff;
                    cursor: pointer;
                    margin-left: 0.2rem;
                    padding: 0rem 0.14rem;
                    @media screen and (max-width: 1024px) {
                        border-radius: (0.04rem * $s1024);
                        margin-left: (0.2rem * $s1024);
                        padding: 0 (0.14rem * $s1024);
                    }
                    @media screen and (max-width: 750px) {
                        border-radius: (0.08rem * $s750);
                        margin-left: (0.48rem * $s750);
                        padding: 0 (0.28rem * $s750);
                    }
                }
            }
        }
        .foot-buttons {
            width: 100%;
            position: absolute;
            bottom: 0.3rem;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            align-content: center;
            @media screen and (max-width: 1024px) {
                bottom: (0.3rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                bottom: (0.3rem * $s750);
            }
            .abtn {
                width: 1.58rem;
                height: 0.36rem;
                font-size: 0.16rem;
                justify-content: center;
                align-content: center;
                align-items: center;
                display: flex;
                border-radius: 0.08rem;
                cursor: pointer;
                @media screen and (max-width: 1024px) {
                    width: (1.58rem * $s1024);
                    height: (0.36rem * $s1024);
                    font-size: (0.16rem * $s1024);
                    border-radius: (0.08rem * $s1024);
                }
                @media screen and (max-width: 750px) {
                    width: (2.76rem * $s750);
                    height: (0.64rem * $s750);
                    font-size: (0.22rem * $s750);
                    border-radius: (0.08rem * $s750);
                }
                &.btnclose {
                    border: 1px solid #eb2234;
                    background: #eb2234;
                    color: #fff;
                }
            }
        }
    }
}
</style>
